import React, { useState, useEffect } from 'react'
import ClientCheck from '../../system/client/ClientCheck';
import dayjs from 'dayjs';
import { Table } from 'antd';
import ReportCheck from './ReportCheck';    
import classes from './report.module.css';
import { Flex, Form, Radio, Badge } from 'antd';
import Icon from '../../cpn/Icon';
import StateTag from '../../cpn/StateTag';
function ReportListApproved(props) {
    const [form] = Form.useForm();
    const [list, setList] = useState(props.spList);
    const [query, setQuery] = useState({
        "dsbzd_sp_state": '',
    });
    useEffect(() => {
        const arr = props.spList.filter((item) => item.dsbzd_sp_jd_name==='审批' && (item.dsbzd_sp_state ==='3' || item.dsbzd_sp_state ==='4' || item.dsbzd_sp_state ==='5' || item.dsbzd_sp_state ==='6'));
        arr.sort((a, b) => new Date(b.dsbzd_sp_ctime) - new Date(a.dsbzd_sp_ctime));
        let newArr = arr.filter((item) => item.dsbzd_sp_state === query.dsbzd_sp_state);
        if(query.dsbzd_sp_state){
            newArr = newArr.filter((item) => item.dsbzd_sp_state === query.dsbzd_sp_state);
            setList(newArr);
        }else{
            setList(arr);
        }
        
    }, [props.spList, query.dsbzd_sp_state]);
    const columns = [
        {
            key: 'dsbzd_sp_state',
            dataIndex: 'dsbzd_sp_state',
            width: '1%',
            render: (_, record) => {
                if(record.dsbzd_sp_state === '3'){
                    return <Icon type='pending' />
                }
                if(record.dsbzd_sp_state === '4'){
                    return <Icon type='rejected' />
                }
                if(record.dsbzd_sp_state === '5'){
                    return <Icon type='finished' />
                }
            },
        },
        {
            title: '团队名称',
            dataIndex: 'dsbzd_sp_dsbzd_name',
            key: 'dsbzd_sp_dsbzd_name',
            width: "20%",
            render: (_, record) =>  <ReportCheck 
                                        dsbzd_id={record.dsbzd_sp_dsbzd_id} 
                                        dsbzd_name={record.dsbzd_sp_dsbzd_name} 
                                        dsbzd_date={record.dsbzd_sp_dsbzd_date}
                                        dsbzd_date_end={record.dsbzd_sp_dsbzd_date_end}
                                        dsbzd_kh_id={record.dsbzd_sp_dsbzd_kh_id}
                                        dsbzd_kh_name={record.dsbzd_sp_dsbzd_kh_name}
                                        yh_id={props.yh_id}  
                                        yh_name={props.yh_name} 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name}
                                    />
        },
        {
            key: 'dsbzd_sp_dsbzd_date',
            dataIndex: 'dsbzd_sp_dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_sp_dsbzd_kh_name',
            dataIndex: 'dsbzd_sp_dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) => <ClientCheck kh_id={record.dsbzd_sp_dsbzd_kh_id} kh_name={record.dsbzd_sp_dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            key: 'dsbzd_sp_uname',
            dataIndex: 'dsbzd_sp_uname',
            title: "提交人",
            width: "8%",
            render: (text, record) => <>{record.dsbzd_sp_uname} {record.dsbzd_sp_ctime}</>,
        },
        {
            title: '状态',
            dataIndex: 'dsbzd_sp_state',
            width: '5%',
            key: 'dsbzd_sp_state',            
            render:(text) => {
                switch(text){
                    case '3':
                        return '已同意'
                    case '4':
                        return '已驳回'
                    case '5':
                        return '已结束'
                    default:
                        return '未知'
                }
            }
        },       
        {
            title: '编号',
            dataIndex: 'dsbzd_sp_dsbzd_id',
            width: '5%',
            key: 'dsbzd_sp_dsbzd_id',                        
        },       
    ]
    return (
        <>
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_submitted'
                    form={form}
                    initialValues={{                        
                        dsbzd_sp_state: query.dsbzd_sp_state ? query.dsbzd_sp_state : '',
                    }}                    
                >
                    <Form.Item 
                        name='dsbzd_sp_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    dsbzd_sp_state: e.target.value, 
                                }));
                                localStorage.setItem('jtg-caiwu_reportList_dsbzd_sp_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.rejectedNum}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束</Radio>
                        </Radio.Group>        
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.customTable}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='dsbzd_sp_id'
                locale={{
                    emptyText: '暂无团队报账单' // This will display text when the table is empty
                }}
            />

        </>
    )
}

export default ReportListApproved